import { authService } from '@/services';
import hubStorage from '@/helpers/hubStorage';
import { vuexEventPathGenerator } from '@/utils';
import { mutationType } from './mutations';
export const actionType = {
    setAccessToken: 'setAccessToken',
    getAccessToken: 'getAccessToken',
    refreshAccessToken: 'refreshAccessToken',
    removeAccessToken: 'removeAccessToken',
};
export const authActionType = vuexEventPathGenerator(actionType, 'auth');
const action = {
    async [actionType.setAccessToken]({ commit }, payload) {
        hubStorage.setAccessToken(payload);
        commit(mutationType.SET_ACCESS_TOKEN, payload);
    },
    async [actionType.getAccessToken]({ commit }, payload) {
        const accessToken = await authService.getAccessToken(payload);
        commit(mutationType.SET_ACCESS_TOKEN, accessToken);
    },
    async [actionType.refreshAccessToken]({ commit }) {
        const accessToken = await authService.refreshToken();
        commit(mutationType.SET_ACCESS_TOKEN, accessToken);
    },
    async [actionType.removeAccessToken]({ commit }) {
        authService.removeAccessToken();
        commit(mutationType.SET_ACCESS_TOKEN, null);
    },
};
export default action;
